import { combineReducers } from 'redux'
import { combineActions, handleActions } from 'redux-actions'
import injectReducer from '../../state/hoc/injectReducer'

import * as entities from './schema'

import {
  createRequestingReducer,
  createErrorReducer,
  resultHandler,
  createInitialStateHandler,
  payloadHandler
} from '../../utils/reducer'
import { tokenCleanUpActions } from '../Login/reducer'
import { SET_CURRENT_APPLICATION } from './actions'
import {
  HACIENDA_BLOCKED,
  fetchAllApplysRoutine,
  fetchApplyByIdRoutine,
  createApplyRoutine,
  createHaciendaRoutine
} from './routines'

export const REDUCER_KEY = 'applications'

// combined actions to handle
const requestActions = combineActions(
  fetchAllApplysRoutine.REQUEST,
  fetchApplyByIdRoutine.REQUEST
)
const fulfillActions = combineActions(
  fetchAllApplysRoutine.FULFILL,
  fetchApplyByIdRoutine.FULFILL
)

const errorActions = combineActions(
  fetchAllApplysRoutine.FAILURE,
  fetchApplyByIdRoutine.FAILURE
)

export const cleanupAllActions = combineActions(
  fetchAllApplysRoutine.FAILURE,
  tokenCleanUpActions.toString()
)

export const cleanupCurrentActions = combineActions(
  fetchApplyByIdRoutine.FAILURE,
  tokenCleanUpActions.toString()
)

// reducers
export const requesting = createRequestingReducer(requestActions, fulfillActions)
export const error = createErrorReducer(errorActions, requestActions)

export const isHaciendaBlocked = createRequestingReducer(
  HACIENDA_BLOCKED,
  createHaciendaRoutine.SUCCESS
)

export const all = handleActions({
  [fetchAllApplysRoutine.SUCCESS]: resultHandler,
  [createApplyRoutine.SUCCESS]: (state, action) => [
    ...state,
    action.payload.result.response
  ],
  [cleanupAllActions]: createInitialStateHandler([])
}, [])

export const current = handleActions({
  [fetchApplyByIdRoutine.SUCCESS]: resultHandler,
  [SET_CURRENT_APPLICATION]: payloadHandler,
  [cleanupCurrentActions]: () => null
}, null)

// root reducer reducers
const reducer = combineReducers({
  requesting,
  error,
  all,
  current,
  isHaciendaBlocked
})

// injector
const entitiesToRegister = [
  entities.ACTIVITY,
  entities.APPLICATION,
  entities.DATA,
  entities.DOCUMENT_INFO,
  entities.DOCUMENTS,
  entities.FINANCIAL,
  entities.INFO,
  entities.NEEDS,
  entities.RESPONSIBLES,
  entities.COLLABORATORS,
  entities.SOLICITUDE,
  entities.SOLICITUDE_EXTRA
]

export const withApplicationsReducer = injectReducer({
  key: REDUCER_KEY,
  reducer,
  entities: entitiesToRegister
})

export default reducer
